module.exports = __webpack_public_path__ + "img/search.498af52c.svg";